import store from '@/store'
import redirectToLogin from '@/router/redirect-to-login'

export default async (to, from, next) => {
    if (!store.getters.auth) {
        redirectToLogin(from, next)
        return
    }

    next()
}
